import Box from '@mui/material/Box';
import { Helmet } from 'react-helmet-async';
import Empty from '~/Components/Empty';

export default () => (<>
    <Helmet>
        <title>Page Not Found | SaintsField</title>
    </Helmet>
    <Box sx={{margin: 5}}>
        <Empty>
            Page Not Found
        </Empty>
    </Box>
</>);
